import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-home-redirect',
    template: '',
})
export class HomeRedirectComponent implements OnInit {

    constructor(private _router: Router,
                private _userService: UserService) {
    }

    ngOnInit(): void {
        this._userService.user$.pipe(take(1)).subscribe(
            {
                next: (user) => {
                    if (!user) {
                        this._router.navigate(['sign-in']);
                        return;
                    }

                    if (!user.permissions.isEmailConfirmed) {
                        this._router.navigate(['confirmation-required']);
                        return;
                    }

                    if (!user.permissions.platformAccess) {
                        this._router.navigate(['account-locked']);
                        return;
                    }

                    switch (user.role) {
                        case"label":
                        case"marketing":
                        case "user":
                            this._router.navigate(['dashboard']);
                            break;
                        case "partner":
                            this._router.navigate(['partner/dashboard']);
                            break;
                        case "admin":
                            this._router.navigate(['admin/dashboard']);
                            break;
                    }

                },
                error: error => this._router.navigate(['sign-in'])
            });

    }

}
